import { GetListParams } from 'react-admin';
import { registerModuleDataProvider, CustomDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { apiGet, apiSend } from '../perps-v1-shared/api';
import { MarketView } from '../perps-v1-shared/types';

// getList -> GET /perps-v1/views（全量树，含 disabled）；其余动作走 api.ts 直连
export class PerpsV1ViewsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, _params: GetListParams): Promise<any> {
    if (resource !== Resources.perpsV1Views) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const json = await apiGet<{ data: MarketView[]; total: number }>('/perps-v1/views');
    return { data: json?.data ?? [], total: json?.total ?? 0 };
  }
}

export const perpsV1ViewsDataProvider = new PerpsV1ViewsDataProvider();

// Row shape returned by the read-only preview endpoint — runs the DRAFT view definition through
// the real interpreter without persisting anything.
export interface PreviewRow {
  id: string;
  symbol: string;
  displaySymbol: string;
  dex: string;
  source: 'pinned' | 'manual' | 'rule';
  markPx: string;
  changePercent24h: string;
  volume24h: string;
  // Same provenance as AdminMarket.marketCap; "0" = goback has not computed one for this symbol.
  marketCap: string;
  listedAt: string;
}

export interface PreviewResponse {
  data: PreviewRow[];
  total: number;
  // Full ordered match set (pinned + manual + rule), BEFORE excludeSymbols is applied and never
  // truncated by `limit` — unlike `data` (which is what the live preview table actually renders,
  // i.e. the final post-exclude result capped at `limit`). Used only to compute candidate pools
  // for the Available (include) and Exclude pickers, never to alter what the table shows.
  matchedSymbols: string[];
}

export const viewsApi = {
  create: (body: unknown) => apiSend<MarketView>('/perps-v1/views', 'POST', body),
  update: (code: string, body: unknown) => apiSend<MarketView>(`/perps-v1/views/${code}`, 'PUT', body),
  setEnabled: (code: string, enabled: boolean) =>
    apiSend<MarketView>(`/perps-v1/views/${code}/enabled`, 'PUT', { enabled }),
  remove: (code: string) => apiSend<{ deleted: boolean }>(`/perps-v1/views/${code}`, 'DELETE'),
  reorder: (parentCode: string | null, orderedCodes: string[]) =>
    apiSend<{ data: MarketView[] }>('/perps-v1/views/reorder', 'PUT', {
      ...(parentCode ? { parentCode } : {}),
      orderedCodes,
    }),
  // Read-only: body is the SAME view-definition payload create/update send, plus `limit`.
  // Nothing is persisted server-side.
  preview: (body: unknown) => apiSend<PreviewResponse>('/perps-v1/views/preview', 'POST', body),
};
